export default "__VITE_ASSET__BV6r$DSG__"